module.exports = __webpack_public_path__ + "static/media/background.cb1d3299.jpeg";